import formatName from 'I18n/utils/formatName';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const getDisplayNameForUser = user => {
  const firstName = user.get('firstName');
  const lastName = user.get('lastName');
  if (firstName && lastName) {
    return formatName({
      firstName,
      lastName
    });
  }
  return user.get('email');
};
export const getSearchHelpText = (usersToTeamMap, user, isDeactivated) => {
  const userId = user.get('id');
  const teamName = userId !== undefined && usersToTeamMap.get(userId) && usersToTeamMap.get(userId).get('name');
  const renderTeamMessage = () => {
    // If the user is activated, we need top margin. If deactivated, the empty space is used for the deactivated label
    if (!teamName) {
      return /*#__PURE__*/_jsx(View, {
        marginBlockStart: isDeactivated ? '0' : '200',
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "userSearch.noTeamAssigned"
        })
      });
    }
    return /*#__PURE__*/_jsx(View, {
      marginBlockStart: isDeactivated ? '0' : '200',
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "userSearch.team",
        options: {
          teamName
        }
      })
    });
  };
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    children: [isDeactivated && /*#__PURE__*/_jsx(Text, {
      as: "small",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "userSearch.deactivatedUserResult"
      })
    }), renderTeamMessage()]
  });
};